import { LitElement, css } from 'lit';
import { customElement } from 'lit/decorators.js';

import './utilities/fileOpenHandler';

import './components/app-header';
import './components/app-content';
import './components/app-nav';
import './components/play-bar';
import './components/play-pause-button';
// import './components/volume-dial';
import './pages/app-home';

import { router } from './router';

if (import.meta.env.DEV) {
  document.title = "Playa (DEV)";
}

@customElement('app-index')
export class AppIndex extends LitElement {
  static styles = css`
    main {
      padding-left: 16px;
      padding-right: 16px;
      padding-bottom: 16px;
    }
  `;

  firstUpdated() {
    router.addEventListener('route-changed', () => {
      if ("startViewTransition" in document) {
        (document as any).startViewTransition(() => this.requestUpdate());
      }
      else {
        this.requestUpdate();
      }
    });
  }

  render() {
    // router config can be round in src/router.ts
    return router.render();
  }
}
